<div class="min-h-[80vh] w-full bg-[#f1f2f3] pb-5">
  <div class="w-full bg-[#001847] h-[370px] relative" id="mask-image">
    <div class="container">
      <div class="w-full text-center relative  float-end mt-5 h-[360px]">
        <h1 class="text-white fw-medium fs-3 m-0 pb-2 mb-1   mt-5">ایران هتل
        </h1>
        <h2 class="text-white fs-1.6">هتل های زنجیره ای</h2>
   
      </div>

    </div>
  </div>
  <div class="container">
    <div class="w-full  mt-10">
      <nav>
        <ol class="breadcrumb-wrapper flex-wrap flex items-center gap-2">
          <li [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'"
            *ngFor="let bread of listBreadcrumb; let last = last; let index = index;let first = first">
            <ng-container *ngIf="!last">
              <a [href]="first ? '/' : bread.Url">
                {{ bread.Name }}
              </a>
            </ng-container>
            <ng-container *ngIf="last">
              <span class=""> {{ bread.Name }} </span>
            </ng-container>

          </li>
        </ol>
      </nav>   
    </div>
   <div class="w-full  mt-10">
  <!-- this is the content -->
  <ng-container *ngIf="!isLoading">
  <div class="flex justify-between hotel-list__item flex-wrap" *ngFor="let item of data?.HotelPartials">
    <div class="images position-relative lg:w-[340px] w-full h-[215px]">
      <a [href]="item.HotelUrl" class="d-block w-full h-100">
        <img [src]="item.MainPicture"
          width="323" height="215"
          (error)="item.MainPicture  = cdnUrl + '/images/no-image.jpg'"
          alt="hotel-list-image" class="d-block !w-full lg:w-[323px]  lazyloaded" loading="lazy">
        <p class="discount-label__segment px-3 border-solid  border-2 user-select-none text-white" 
        *ngIf="roundDiscount(item.TopDiscount) > 0">
          <span class="d-inline fw-light">تا</span>
          <span class="discount--number d-inline fw-bold">
            {{ roundDiscount(item.TopDiscount) }}%
          </span>
          <span class="d-inline fw-light">تخفیف</span>
        </p> <!--///////// discount-label__segment /////////-->
      </a>
    </div> <!--///////// images /////////-->
  
    <div class="wrapper p-3 bg-white lg:w-[68%] w-full flex flex-wrap lg:flex-nowrap">
      <div class="first-wrapper lg:w-[80%] w-full">
        <h2 class="text-lg font-bold m-0 text-black pt-1">
          <a [href]="item.HotelUrl" class="d-block w-full h-100">هتل {{item.HotelName}} {{item.CityTitle}}</a>
        </h2>
  
        <div
          class="stars__segment position-relative overflow-hidden user-select-none mt-1 stars__segment--small stars__segment--hotel-rate">
          <div class="flex items-center gap-2" >
            <i class="ico-Star-bold text-xl text-black-300"></i>
            <span class="text-black-300 text-sm">{{ item.HotelGrade }} ستاره</span>
          </div>
        </div> <!--///////// stars /////////-->
  
        <address class="address__segment text-black-300  flex flex-row justify-content-start items-center pt-2 text-xs m-0">
          <i class="ico-Location-card-bold text-xl text-black-300"></i>
          <p class="truncate">{{item.HotelAddress}}</p>
        </address> <!--///////// address__segment /////////-->
  
  
        <div class="description text-black-300 text-sm">
          <p>{{item.PublicInfo}}</p>
        </div>
      </div> <!--///// first-wrapper /////-->
  
      <div class="second-wrapper w-1/3">
        <div
          class="score__segment relative overflow-hidden flex flex-row-reverse  w-full whitespace-nowrap flex-nowrap lg:justify-start justify-end items-center mt-2"> 
          <div
            class="wrapper score__number--border text-center flex items-center justify-center px-1 h-100 me-2"> 
            <p class="score__number fs-1.2 px-1 pt-2 text-white">{{item.Rate}}</p>
          </div>
  
          <div class="wrapper text-left">
            <p class="score__text text-xs font-bold pb-2 text-black">خوب</p>
            <p class="score__description text-xs text-gray-500">از {{item.VoteCount}} نظر واقعی</p>
          </div>
        </div> <!--///////// score__segment /////////-->
  
        <div class="third--wrapper">
  
  
          <p class="btn-reservation">
            <a  mat-button color="primary" class="lg:w-[150px] w-full !h-11" [href]="item.HotelUrl" >رزرو هتل</a>
          </p>
        </div><!--///// third--wrapper /////-->
      </div> <!--///// second-wrapper /////-->
  
    </div> <!--///////// wrapper /////////-->
  </div>
  </ng-container>
  <!-- Skeleton cards -->
  <ng-container *ngIf="isLoading">
    <div class="hotel-list__item hotel-card-skeleton flex justify-between flex-wrap"
      *ngFor="let skeleton of skeletonItems">
      <div class="skeleton-image lg:w-[340px] w-full h-[215px]"></div>
  
      <div class="skeleton-content p-3 bg-white lg:w-[68%] w-full flex flex-wrap lg:flex-nowrap">
        <div class="lg:w-[80%] w-full">
          <div class="skeleton-line skeleton-title"></div>
  
          <div class="skeleton-line skeleton-stars"></div>
  
          <div class="skeleton-line skeleton-address"></div>
  
          <div class="skeleton-line skeleton-description"></div>
          <div class="skeleton-line skeleton-description skeleton-description-short"></div>
        </div>
  
        <div class="skeleton-side lg:w-1/3 w-full">
          <div class="skeleton-score">
            <div class="skeleton-score-number"></div>
  
            <div class="skeleton-score-text">
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
            </div>
          </div>
  
          <div class="skeleton-button"></div>
        </div>
      </div>
    </div>
  </ng-container>

   </div>
  </div>

</div>